import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { Bookmark, Bookmarked } from '@finect/tabular-icons/bookmark';
import { Flex } from '@finect/tabular-core/Flex';
import { Share2 } from '@finect/tabular-icons/share2';
import { PlusCircle } from '@finect/tabular-icons/plusCircle';
import { Share } from '../../../../Share';
import { Page, PageTitle, ButtonActionComparison, HeaderInner } from './partials';
var ComparisonHeader = function ComparisonHeader(_ref) {
  var theme = _ref.theme,
    disabled = _ref.disabled,
    saved = _ref.saved,
    onSave = _ref.onSave,
    onDelete = _ref.onDelete,
    onUserComparisonsOpen = _ref.onUserComparisonsOpen,
    onClearComparison = _ref.onClearComparison,
    shareTitle = _ref.shareTitle,
    shareUrl = _ref.shareUrl;
  var handleSaveSearch = onSave ? onSave : function () {};
  var handleDeleteSearch = onDelete ? onDelete : function () {};
  return React.createElement(HeaderInner, null, React.createElement(Page, {
    justify: "space-between"
  }, React.createElement(PageTitle, {
    as: theme.partner.headings.title,
    large: true
  }, "Comparador de fondos"), React.createElement(Flex, {
    justify: "flex-end"
  }, !disabled ? React.createElement(Fragment, null, React.createElement(ButtonActionComparison, {
    secondary: true,
    onClick: onClearComparison,
    width: "auto"
  }, React.createElement(PlusCircle, null), "Nueva comparaci\xF3n"), React.createElement(Share, {
    title: shareTitle,
    url: shareUrl,
    via: "Finect",
    positionX: "bottom",
    arrowPosition: 0
  }, React.createElement(ButtonActionComparison, {
    width: "auto"
  }, React.createElement(Share2, null), React.createElement("span", null, "Compartir"))), React.createElement(ButtonActionComparison, {
    isActive: saved,
    disabled: disabled,
    width: "auto",
    onClick: saved ? handleDeleteSearch : handleSaveSearch
  }, saved ? React.createElement(Bookmarked, null) : React.createElement(Bookmark, null), React.createElement("span", null, saved ? 'Guardado' : 'Guardar'))) : React.createElement(ButtonActionComparison, {
    onClick: onUserComparisonsOpen,
    width: "auto"
  }, "Comparaciones guardadas"))));
};
export default withTheme(ComparisonHeader);